// src/components/CardUmat.js
import React from "react";
import PropTypes from "prop-types";
import { getAvatarPlaceholder } from "../utils/wkCommon";

/**
 * Reusable card for daftar umat / search results
 *
 * Props:
 *  - avatar: image URL (optional)
 *  - line1: primary line (kode | chinese + pinyin)
 *  - line2: secondary (fullName or nickname)
 *  - line3: tertiary (district / address)
 *  - onClick: function called when card is clicked
 *  - className: optional extra class names
 */
export default function CardUmat({ avatar, line1, line2, line3, onClick, className = "" }) {
  const avatarSrc = avatar || getAvatarPlaceholder();

  // keyboard activation for accessibility
  function handleKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick && onClick(e);
    }
  }

  return (
    <div
      className={`content-row ${className}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <div className="row-left">
        <div className="avatar">
          <img
            src={avatarSrc}
            alt={line2 || line1 || "avatar"}
            style={{
              width: "5rem",           // 80px ~= 5rem (assuming 16px base)
              height: "5rem",
              objectFit: "cover",
              borderRadius: "0.375rem" // 6px ~= 0.375rem
            }}
          />
        </div>
      </div>

      <div className="row-body">
        <div className="row-code" style={{ fontWeight: 700, fontSize: "1rem" }}>{line1}</div> { /* code | chineseName pinyinName */ }
        <div className="row-nick" style={{ fontSize: "0.9375rem", marginTop: "0.25rem" }}>{line2}</div> { /* fullName */}
        <div className="row-address" style={{ fontSize: "0.875rem", marginTop: "0.125rem", color: "#555" }}>{line3}</div> { /* area | fotangName */}
      </div>

      <div className="row-right" />
    </div>
  );
}

CardUmat.propTypes = {
  avatar: PropTypes.string,
  line1: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  line2: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  line3: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  className: PropTypes.string,
};
